<template>
    <div class="flex items-center justify-end space-x-4">
        <div class="flex">
            <ui-dropdown placement="bottom-end" menu-class="p-3 w-72" :key="userKey">
                <template #default="{ toggle }">
                    <ui-button-new @click="toggle" small primary>
                        Actions
                        <i class="flex-shrink-0 ml-2 fa fa-chevron-down"></i>
                    </ui-button-new>
                </template>

                <template #menu="{ close }">
                    <ui-dropdown-item icon="fas fa-share" @click="send">Send</ui-dropdown-item>
                    <ui-dropdown-item icon="fas fa-file-pdf" @click="download">Download as PDF</ui-dropdown-item>
                    <ui-dropdown-item icon="fas fa-print" @click="print">Print PDF</ui-dropdown-item>
                    <ui-dropdown-divider></ui-dropdown-divider>
                    <ui-dropdown-item icon="fas fa-copy"
                                      @click="copyRams();close()">
                        Copy RAMS
                    </ui-dropdown-item>
                    <ui-dropdown-item icon="fas fa-paste"
                                      @click="duplicate();close()">
                        Duplicate RAMS
                    </ui-dropdown-item>
                    <ui-dropdown-divider v-if="rams.canDelete"></ui-dropdown-divider>
                    <ui-dropdown-item v-if="rams.canDelete" danger icon="fa fa-trash" @click="deleteRams">Delete
                    </ui-dropdown-item>
                </template>
            </ui-dropdown>
        </div>
    </div>
</template>

<script>
import {RAMS} from "../../../models";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import {cloneDeep} from "lodash";
import remoteStorage from "../../../utils/remoteStorage";
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import UiDropdown from "../../ui/UiDropdown.vue";

export default {
    components: {UiDropdown, UiDropdownDivider, UiButtonNew, UiDropdownItem},
    props: {
        rams: RAMS,
        user: Object,
        deleteRams: Function,
    },
    data() {
        let ramsClipboardData = [];
        try {
            ramsClipboardData = remoteStorage.getItem('rams-clipboard') ? JSON.parse(remoteStorage.getItem('rams-clipboard')) : [];
        } catch (e) {
            //continue on JSON ERROR
        }

        return {
            states: [],
            position: 0,
            selectedPage: [],
            userKey: 1,
            ramsClipboard: ramsClipboardData ? ramsClipboardData : [],
        }
    },
    watch: {
        userClipboardToBeWatched: {
            handler(newValue, oldValue) {
                let value = remoteStorage.getItem('rams-clipboard') ? JSON.parse(remoteStorage.getItem('rams-clipboard')) : []
                this.ramsClipboard = value ? value : []
                this.userKey++;
            },
        },
    },
    computed: {
        userClipboardToBeWatched() {
            return this.user.remoteStorage ? this.user.remoteStorage['rams-clipboard']
                : '';
        },
    },
    methods: {
        copyRams() {
            this.ramsClipboard[0] = cloneDeep(this.rams)
            remoteStorage.setItem('rams-clipboard', JSON.stringify(this.ramsClipboard))
        },
        duplicate() {
            this.$emit('duplicate', this.rams)
        },
        print() {
            this.$emit('print', this.rams.getPrintableUrl())
        },
        download() {
            window.location.href = this.rams.getDownloadUrl()
        },
        send() {
            this.$modals.open('rams-send', {item: this.rams})
        },
    },
    mounted() {
    }
}
</script>
